export default "__VITE_ASSET__L1raOHB9__"